import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Scale, FileText, Users, Clock } from 'lucide-react';
import heroImage from '@/assets/hero-law.jpg';

const Litigation = () => {
  return (
    <section id="litigation" className="relative min-h-screen">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-primary/80"></div>
      </div>
      
      <div className="relative z-10 pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="font-rockwell text-5xl md:text-6xl font-bold text-hero-foreground mb-6 uppercase tracking-wide">
              Important Notice
            </h1>
            <p className="text-xl text-hero-foreground/90 max-w-3xl mx-auto leading-relaxed mb-8">
              Protecting our God-given rights through strategic litigation support and lawful guidance in federal and state courts.
            </p>
            
            <div className="bg-hero-foreground/10 border border-hero-foreground/20 rounded-lg p-6 max-w-2xl mx-auto">
              <p className="text-lg text-hero-foreground font-medium text-center">
                We are currently not accepting new litigation cases at this time. Please check back soon as we will be opening our doors to new cases in the near future.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Litigation;